import jQuery from 'jquery'
import Swal from 'sweetalert2'
import '@fortawesome/fontawesome-free'
import 'bootstrap'
import AOS from 'aos'
import 'aos/dist/aos.css'
import Swiper from 'swiper'
import { Navigation, Pagination, EffectFade, Thumbs, Autoplay, EffectCoverflow, Mousewheel } from 'swiper/modules'
import lottie from 'lottie-web'
import 'jquery-mask-plugin'
import anime from 'animejs/lib/anime.es.js'
import lozad from 'lozad'

window.$ = window.jQuery = jQuery
window.Swal = Swal
window.AOS = AOS
window.Swiper = Swiper
window.Navigation = Navigation
window.Pagination = Pagination
window.EffectFade = EffectFade
window.Autoplay = Autoplay
window.Thumbs = Thumbs
window.EffectCoverflow = EffectCoverflow
window.Mousewheel = Mousewheel
window.JqueryMaskPlugin = $
window.anime = anime
window.lozad = lozad
